import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useLocation } from 'react-router-dom';

import { fbAuth } from '@/lib/firebase/init';
import { ROUTES } from '@/lib/routes';

import LogoutButton from './LogoutButton/LogoutButton';
import SidebarLink from './SidebarLink/SidebarLink';
import UserInfo from './UserInfo/UserInfo';
import { SidebarConfig } from './sidebar-config';

const Sidebar = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [user] = useAuthState(fbAuth);

  const activeRoute = Object.keys(SidebarConfig).find((route) =>
    location.pathname.startsWith(route),
  ) as keyof typeof SidebarConfig;
  const config = SidebarConfig[activeRoute];
  const currentLink = config?.links.find((link) => location.pathname === link.path)?.name;

  if (!config) {
    console.warn('No config found for route:', location.pathname);
    return null;
  }

  return (
    <div className="flex justify-between">
      <div className="sidebar flex flex-col w-[200px] justify-between items-center h-screen  bg-white-100 p-4 pt-16 sticky top-0">
        <div className="w-fill-available w-[172px]">
          <Link to={ROUTES.HOME}>
            <img src={config.icon} alt="Logo" className="mb-16 m-auto" />
          </Link>

          <nav>
            {config.links.map((link) => (
              <SidebarLink key={link.path} link={link} active={currentLink === link.name} />
            ))}
          </nav>
        </div>

        <div className="mt-auto w-full">
          <UserInfo user={user} />
          <LogoutButton />
        </div>
      </div>
      {children}
    </div>
  );
};

export default Sidebar;
